// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"fe23ff26","268":"341c998b","517":"09ae88ad","655":"bf0dc577","745":"35a8aaa0","773":"7da5f120","915":"2eac1e3e"}[chunkId] + ".chunk.js";
};